const isElementHidden = (element, type) => {
  // always hidden elements
  if (["dialog", "trix-toolbar", "trix-editor"].includes(element.tagName.toLowerCase())) {
    return true;
  }

  if (!type) {
    return false;
  }

  const classes = [...element.classList].map((c) => c.replaceAll("!", "")); // ignore important modifier for checking classes

  // check if element is hidden for the type
  if (classes.includes(`in-[.print-${type}]:print:hidden`)) {
    return true;
  }

  // check if element is hidden in general
  if (classes.some((c) => c === "hidden" || c === "print:hidden")) {
    // if element is shown when printing, then it's not hidden
    return !classes.some(
      (c) =>
        c === "print:block" ||
        c === "print:inline" ||
        c === "print:flex" ||
        c === `in-[.print-${type}]:print:block` ||
        c === `in-[.print-${type}.print-with-doctor-feedback]:print:block` ||
        c === `in-[.print-${type}]:print:flex` ||
        c === `in-[.print-${type}.print-with-doctor-feedback]:print:flex` ||
        c === `in-[.print-${type}]:print:inline` ||
        c === `in-[.print-${type}.print-with-doctor-feedback]:print:inline`,
    );
  }

  return false;
};

/**
 * Returns reduced DOM to print as pdf
 */
const readDom = (type) => {
  let temporaryDiv = document.createElement("div");

  // copy body.innerHTML to tmpDiv
  temporaryDiv.innerHTML = document.body.innerHTML;

  // remove all comment nodes first
  let walker = document.createTreeWalker(temporaryDiv, NodeFilter.SHOW_COMMENT);
  let comments = [];
  while (walker.nextNode()) comments.push(walker.currentNode);
  comments.forEach((comment) => comment.remove());

  // get all html elements
  let allElements = temporaryDiv.querySelectorAll("*");

  // cleanup...
  for (let element of allElements) {
    if (isElementHidden(element, type)) {
      element.remove();
    }

    // or delete data-* attributes
    else {
      // get all attributes
      let attributes = element.attributes;

      // loop through attributes from end to start (to avoid issues when removing attributes)
      for (let j = attributes.length - 1; j >= 0; j--) {
        let attribute = attributes[j];

        // remove data-* attributes
        if (attribute.name.startsWith("data-")) {
          element.removeAttribute(attribute.name);
        }
      }
    }
  }

  return temporaryDiv.innerHTML;
};

export default readDom;
